import { Grid } from "@mui/material";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { BaseDataPageHeader } from "components/basedata-page-header/basedata-page-header.component";
import { GroupProvider } from "components/group/group-table/group-context";
import { GroupTable } from "components/group/group-table/group-table.component";
import { GroupTableProvider } from "components/group/group-table/group-table.provider";

export const GroupOverviewPage: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <GroupProvider>
      <GroupTableProvider>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <BaseDataPageHeader title={t("basedata.groups.heading")} />
          </Grid>
          <Grid item xs={12}>
            <GroupTable />
          </Grid>
        </Grid>
      </GroupTableProvider>
    </GroupProvider>
  );
};
